import { navLinks } from "@/mocks/home";

export default function Footer() {
  return (
    <footer className="bg-secondary-100 border-t border-secondary-200">
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          <div>
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-lg">
                <i className="ri-cup-line" />
              </span>
              <span className="font-heading font-bold text-lg text-foreground-950">
                茶杯狐影视
              </span>
            </div>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed max-w-xs">
              集中介绍茶杯狐影视的 APP、客户端、会员与 VIP，以及弹幕与收藏等功能的单页说明站。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-foreground-900">页面分区</h3>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="text-sm text-foreground-600 hover:text-primary-700 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-foreground-900">说明</h3>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
              本页面为功能与使用说明类内容，所展示的界面与片单均为示意，实际功能与可用内容以客户端内为准。
              请通过官方渠道获取相关客户端与应用。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2026 茶杯狐影视 · 功能说明页
          </p>
          <p className="text-xs text-foreground-500">
            关键词：茶杯狐影视 · APP · 客户端 · 会员 · VIP · 弹幕 · 收藏
          </p>
        </div>
      </div>
    </footer>
  );
}